import { render, staticRenderFns } from "./address-info.vue?vue&type=template&id=f1668d20&scoped=true"
import script from "./address-info.vue?vue&type=script&lang=js"
export * from "./address-info.vue?vue&type=script&lang=js"
import style0 from "./address-info.vue?vue&type=style&index=0&id=f1668d20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1668d20",
  null
  
)

export default component.exports